import React, { memo } from 'react';
import Image from 'next/image';
import PropTypes from 'prop-types';
import withViewport from '@aveneo/frontmoon-viewport-watcher/lib/hocs/withViewport';
import withProps from 'recompose/withProps';

import MasonryLayout from 'src/components/MasonryLayout';

import theme from 'src/styles/components/Menu.module.scss';

import { useIntl } from 'react-intl';
import MenuItemRenderer from './MenuItemRenderer';

const Menu = memo(({
    selectedCategoryIndex,
    flatMenu
}) => {
    const intl = useIntl();

    return (
        <div className={theme.container}>
            <div className={theme.menuPositions} id="menuPositions">
                {flatMenu.length > 0 && (
                    <MasonryLayout
                      gap={20}
                      scrollToIndex={selectedCategoryIndex}
                      items={flatMenu}
                      render={withProps({ containerId: 'menuPositions' })(MenuItemRenderer)}
                    />
                )}
                {flatMenu.length === 0 && (
                    <div className={theme.noMenuContainer}>
                        <Image
                          src="/images/restaurant-not-found-icon.svg"
                          width={120}
                          height={120}
                          unoptimized="true"
                        />
                        <div className={theme.noMenuDescription}>
                            {intl.formatMessage({ id: 'App.menuIsBuilding' })}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
});

Menu.propTypes = {
    flatMenu: PropTypes.arrayOf(PropTypes.object),
    selectedCategoryIndex: PropTypes.number
};

export default withViewport(Menu);
